// extracted by mini-css-extract-plugin
export default {"title":"DialogWindow_title__AUHck","bold":"DialogWindow_bold__TKVu5"};